import React from 'react'
import type { ActivityProviderProps } from './Context'
import { ActivityProvider, useActivityContext } from './Context'
import { Stack } from 'react-bootstrap'
import { ActivityList } from './ActivityList'
import { Scrollable, ShowIf } from '@ztechapps/webui.util'
import { ShowHistoryButton } from './ShowHistoryButton'

export type ActivityProps = Omit<ActivityProviderProps, 'children'> & {
  documentId: string
}

export const ActivityLayout = ({ ...props }: ActivityProps) => {
  return (
    <ActivityProvider {...props}>
      <Layout />
    </ActivityProvider>
  )
}

const Layout = () => {
  const { height, listContainerRef, components, showInput } = useActivityContext()
  const ActivityInput = components.addRemarksInput
  return (
    <Stack gap={2}>
      <ActivityInput />
      <ShowIf condition={showInput}>
        <ShowHistoryButton />
      </ShowIf>
      <Scrollable ref={listContainerRef} height={height}>
        <ActivityList />
      </Scrollable>
    </Stack>
  )
}
